import * as React from "react";
import type { SVGProps } from "react";

interface GoalkeeperSubstitutionProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const GoalkeeperSubstitution = ({ cancelled = false, ...props }: GoalkeeperSubstitutionProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        d="M20.9 5.25c1.3 0 2.35 1.05 2.35 2.35v10.94c0 .69-.56 1.25-1.25 1.25h-.37c-.2 0-.4-.05-.57-.14H2.94c-.13.07-.28.12-.44.13H2c-.69 0-1.25-.55-1.25-1.24V7.6c0-1.3 1.05-2.35 2.35-2.35Z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M20.9 6c.88 0 1.6.72 1.6 1.6v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V7.6c0-.13-.1-.23-.23-.23H3.1c-.13 0-.23.1-.23.23v10.94a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7.6c0-.88.72-1.6 1.6-1.6z"
      />
      <g fillRule="nonzero">
        <path
          fill="#000"
          d="M7.21 18.51a.42.42 0 0 1-.3-.72L17.8 6.91a.42.42 0 0 1 .72.3v8.23c0 .38-.45.57-.72.3l-1.65-1.65-4.3 4.3a.42.42 0 0 1-.23.12H7.2Z"
        />
        <path
          fill="#FFF"
          d="M7.21 19.51a1.42 1.42 0 0 1-1-2.43L17.08 6.21c.9-.9 2.43-.26 2.43 1v8.23c0 1.27-1.53 1.9-2.43 1l-.94-.94-3.6 3.6c-.18.18-.4.3-.7.37l-.15.03-.15.01zm0-1h4.4a.42.42 0 0 0 .23-.12l4.3-4.3 1.65 1.65c.27.27.72.08.72-.3V7.21a.42.42 0 0 0-.72-.3L6.91 17.8a.42.42 0 0 0 .3.72Z"
        />
        <path
          fill="#000"
          d="M7.21 18.69a.6.6 0 0 1-.42-1.02L17.67 6.79a.6.6 0 0 1 1.02.42v8.23a.6.6 0 0 1-1.02.43l-1.53-1.53-4.18 4.17a.6.6 0 0 1-.24.15l-.1.02H7.21Zm4.32-.35h.05c.05-.01.1-.04.14-.08l4.3-4.3.12-.12 1.77 1.78c.16.15.43.04.43-.18V7.21a.25.25 0 0 0-.43-.17L7.04 17.9a.25.25 0 0 0 .17.43h4.32Z"
        />
        <path
          fill="#60B100"
          d="M11.37 17.67H8.23l9.44-9.44v6.2l-1.23-1.24a.42.42 0 0 0-.6 0z"
        />
        <path
          fill="#000"
          d="M16.59 5.29c.37 0 .56.45.3.72L6 16.89a.42.42 0 0 1-.72-.3V8.36c0-.38.45-.57.72-.3L7.66 9.7l4.3-4.3c.06-.06.15-.1.23-.12h4.4Z"
        />
        <path
          fill="#FFF"
          d="M16.59 4.29c1.26 0 1.9 1.53 1 2.43L6.72 17.59c-.9.9-2.43.26-2.43-1V8.36c0-1.27 1.53-1.9 2.43-1l.94.94 3.6-3.6c.18-.18.4-.3.7-.37l.15-.03.15-.01zm0 1h-4.4a.42.42 0 0 0-.23.12l-4.3 4.3-1.65-1.65a.42.42 0 0 0-.72.3v8.23c0 .37.45.56.72.3L16.89 6a.42.42 0 0 0-.3-.72Z"
        />
        <path
          fill="#000"
          d="M16.59 5.11c.53 0 .8.65.42 1.02L6.13 17.01a.6.6 0 0 1-1.02-.42V8.36a.6.6 0 0 1 1.02-.43l1.53 1.53 4.18-4.17a.6.6 0 0 1 .24-.15l.1-.02h4.41Zm-4.32.35h-.05c-.05.01-.1.04-.14.08l-4.3 4.3-.12.12L5.9 8.18a.25.25 0 0 0-.43.18v8.23c0 .22.27.33.43.17L16.76 5.9a.25.25 0 0 0-.17-.43h-4.32Z"
        />
        <path
          fill="#FF1212"
          d="M12.43 6.13h3.14l-9.44 9.44v-6.2l1.23 1.24c.17.16.44.16.6 0z"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default GoalkeeperSubstitution;
